<template>
  <v-container
    id="order_status"
    v-touch="{
      left: () => swipe('Left'),
      right: () => swipe('Right'),
    }"
    fluid
    tag="section"
    style="height: calc(100% - 110px)"
  >
    <base-material-card
      icon="mdi-eye-refresh"
      class="px-5 py-3"
      width="100%"
      title="Stato Ordini"
    >
      <!-- <v-row class="mt-4">
        <v-col
          cols="12"
        >
          <table
            v-if="cliente"
            class="text-h4 text-weigth-light"
          >
            <tr>
              <td class="text-no-wrap pr-3">
                Cliente
                <div v-if="isMobile">
                  {{ cliente.ragsoc }} {{ cliente.indiri_1 }}<br>
                  {{ cliente.indiri2 }} {{ cliente.locali }}
                </div>
              </td>
              <td v-if="!isMobile">
                {{ cliente.ragsoc }} {{ cliente.indiri_1 }}
              </td>
            </tr>
            <tr v-if="!isMobile">
              <td /><td>{{ cliente.indiri2 }} {{ cliente.locali }} </td>
            </tr>
          </table>
        </v-col>
      </v-row> -->
      <v-row
        class="my-6"
        justify="center"
      >
        <v-radio-group
          v-model="tipoRicerca"
          row
          class="text-h4 text-weigth-light"
          @change="listOrders=false"
        >
          <v-radio
            label="Ricerca per RIFERIMENTO"
            value="riferimento"
          />
          <v-radio
            label="ricerca per PERIODO"
            value="periodo"
          />
        </v-radio-group>
      </v-row>
      <v-row
        v-if="tipoRicerca === 'periodo'"
        no-gutters
        class="mt-6 justify-space-between"
      >
        <v-menu
          v-model="mnu_data_start"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="$formatDate(data_start).substring(0, 10)"
              label="Data Inizio"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="data_start"
            locale="it-IT"
            @input="mnu_data_start = false"
          />
        </v-menu>
        <v-menu
          v-model="mnu_data_end"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="$formatDate(data_end).substring(0, 10)"
              label="Data Fine"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="data_end"
            :allowed-dates="(val) => val >= data_start"
            locale="it-IT"
            @input="mnu_data_end = false"
          />
        </v-menu>
        <v-btn
          color="primary"
          @click="get_statusOrders"
        >
          <v-icon>mdi-magnify</v-icon>
          Cerca
        </v-btn>
      </v-row>
      <v-row
        v-if="tipoRicerca === 'riferimento'"
        no-gutters
        class="mt-6 justify-space-between"
      >
        <v-text-field
          v-model="riferimento"
          label="Riferimento"
          prepend-icon="mdi-glasses"
          @keyup.enter="get_statusOrders"
          @input="riferimento = riferimento.toUpperCase()"
        />
        <v-btn
          color="primary"
          @click="get_statusOrders"
        >
          <v-icon>mdi-magnify</v-icon>
          Cerca
        </v-btn>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            v-if="listOrders?.length>0"
            loading-text="Caricamento..."
            :loading="loading"
            :search="search"
            :items-per-page="-1"
            hide-default-footer
            :headers="headers"
            :items="listOrders"
            class="elevation-1"
            single-expand
            show-expand
            item-key="ORBF_NUMORD"
            :expanded.sync="expanded"
            @item-expanded="orderDDT=''"
          >
            <template v-slot:expanded-item="{ item }">
              <td
                :colspan="headers.length"
                class="text-left pa-4"
              >
                Riferimento: <b>{{ item.ORBF_DESRIF }}</b><br>
                <div
                  v-if="item.DESC_RIP!='' || item.GARANZIA!=''"
                  class="dblock ma-2 font-weight-medium"
                >
                  {{ item.DESC_RIP?item.DESC_RIP:'' }} {{ item.GARANZIA?item.GARANZIA:'' }}
                </div>
                Ord. Num.: <b>{{ item.ORBF_NUMORD }} del {{ item.ORBF_DATORD }} </b><br>
                Data Ordine Lenti: <b>{{ item.ORBF_DATAOLE_1!='01.01.0001'?item.ORBF_DATAOLE_1: item.ORBF_DATAOLE_2!='01.01.0001'?item.ORBF_DATAOLE_2: item.ORBF_DATAOLE_3!='01.01.0001'?item.ORBF_DATAOLE_3:'' }}</b><br>
                Data Arrivo Lenti: <b>{{ item.ORBF_DATARR_1!='01.01.0001'?item.ORBF_DATARR_1: item.ORBF_DATARR_2!='01.01.0001'?item.ORBF_DATARR_2: item.ORBF_DATARR_3!='01.01.0001'?item.ORBF_DATARR_3:'' }}</b><br>

                Stato: <b>{{ item.DESC_STATO }} {{ item.ORBF_DATSPE!='01.01.0001'?item.ORBF_DATSPE:'' }}</b><br>
                <template v-if="+item.ORBF_NUMBOL>0">
                  Bolla nr. <b>{{ item.ORBF_NUMBOL }}</b><br><br>

                  <v-btn
                    v-if="orderDDT==''"
                    x-small
                    color="primary"
                    @click="get_orderDDT(item.ORBF_NUMBOL)"
                  >
                    Dettaglio Corriere
                  </v-btn>
                  <template v-else-if="orderDDT=='load'">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                      size="24"
                    /> Carico ulteriori dettagli...
                  </template>
                  <template v-else>
                    Corriere: {{ orderDDT.DESC_COR }} &nbsp; &nbsp; &nbsp;
                    Data Spedizione: {{ orderDDT.TBLF_DATSPE }}<br>
                  </template>
                </template>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </base-material-card>

    <v-overlay :value="loading">
      <v-row
        style="width:50vw; position:fixed; left:30vw"
      >
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-row>
    </v-overlay>
  </v-container>
</template>

<script>
  import Config from '@/config.js'

  import { mapState } from 'vuex'
  import engine from '@/plugins/engine'

  export default {
    name: 'OrderStatus',
    components: {

    },
    data () {
      return {
        loading: false,
        cliente: null,
        codcli: null,
        search: null,
        valid: true,
        listOrders: false,
        tipoRicerca: null,
        showBackOnline: false,
        mnu_data_start: false,
        data_start: new Date((Date.now() - (new Date()).getTimezoneOffset() * 60000) - (90 * 24 * 60 * 60 * 1000)).toISOString().substring(0, 10),
        mnu_data_end: false,
        data_end: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
        riferimento: null,
        orderDDT: '',
        expanded: [],
        headers: [
          { text: 'Nr. Ordine', value: 'ORBF_NUMORD' },
          { text: 'Data Ordine', value: 'ORBF_DATORD' },
          { text: 'Articolo', value: 'ORBF_CODART' },
          { text: 'Riferimento', value: 'ORBF_DESRIF' },
          { text: 'Stato', value: 'DESC_STATO' },
        ],
      }
    },
    computed: {
      ...mapState(['auth', 'clidata']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },
      config () {
        return Config
      },
    },
    watch: {
      onLine (v) {
        if (v) {
          this.showBackOnline = true
          setTimeout(() => {
            this.showBackOnline = false
          }, 1000)
        }
      },
    },
    mounted () {
      window.addEventListener('online', this.updateOnlineStatus)
      window.addEventListener('offline', this.updateOnlineStatus)
      this.cliente = this.clidata.anacli
      var codsog = this.auth.userinfo.codsog
      var coddes = this.auth.userinfo.coddes.toString().padStart(3, '0')
      this.codcli = `${codsog}${coddes}`
      console.log('analisi codcli', this.codcli)
      this.tipoRicerca = 'riferimento'
      // this.get_statusOrders()
    },
    beforeDestroy () {
      window.removeEventListener('online', this.updateOnlineStatus)
      window.removeEventListener('offline', this.updateOnlineStatus)
    },
    methods: {

      swipe (direction) {
        if (direction === 'Left') {
          this.step++
        } else {
          this.step--
        }
      },
      updateOnlineStatus (e) {
        const { type } = e
        this.onLine = type === 'online'
      },
      get_statusOrders () {
        this.loading = true
        if (this.tipoRicerca === 'riferimento' && (!this.riferimento || this.riferimento === '')) {
          this.$store.commit('setSnack', { message: 'Inserire Riferimento', color: '#c54747d4' })
          this.loading = false
          return
        }
        engine.get_statusOrders(this.codcli, this.data_start, this.data_end, this.riferimento, this.tipoRicerca)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            console.log('RESULT', result)
            this.listOrders = result.data
          })
          .catch((errore) => {
            console.log('search err: ', errore)
          }).finally(() => { this.loading = false })
      },
      get_orderDDT (numbol) {
        if (numbol === this.orderDDT.numbol) {
          return
        }
        this.orderDDT = 'load'
        engine.get_orderDDT(this.codcli, numbol)
          .then(result => {
            if (result.error) {
              this.orderDDT = result.error_reason
            }
            this.orderDDT = result.data || ' -- '
            this.orderDDT.numbol = numbol
          })
      },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      onSubmit () {
        this.valid = this.$refs.form.validate()
        // if (this.valid) {
        //   console.log('send', this.lens)
        //   const data = { lens: this.lens, cliente: this.cliente }
        //   engine.sendRiparazione(data).then((result) => {
        //     if (result) {
        //       // alert('Form has been submitted!')
        //       console.log('sendRiparazione', result)
        //       this.$store.commit('setSnack', { message: 'Inviato ordine di riparazione', color: '#4caf50', timeout: 5000 })
        //     }
        //   })
        //     .catch((errore) => {
        //       // eslint-disable-next-line no-console
        //       console.error('ERR####', errore)
        //     })
        //   return
        // }
        // this.$store.commit('setSnack', { message: 'Inserire Dati Obbligatori', color: '#c54747d4', timeout: 8000 })
        // this.$vuetify.goTo(0) // scroll top
        // console.log('send invadlid', this.lens)

        // engine.sendOrder(this.lens, this.page).then((result) => {
        //   if (result) {
        //     // alert('Form has been submitted!')
        //     console.log('update newitem', result)
        //     this.$emit('updateItem', result)
        //     this.$emit('close')
        //   }
        // })
        //   .catch((errore) => {
        //     // eslint-disable-next-line no-console
        //     console.error('ERR####', errore)
        //     this.$store.commit('setSnack', { message: 'General Error', color: '#c54747d4' })
        //   })
      },
    },
  }

</script>
